import React from 'react'
import { chain, omit } from 'lodash'
import PropTypes from "prop-types"
import { Form, FormControl } from 'react-bootstrap'

import { randstr } from '../../../lib/Tools'
import Button from '../../components/Button.jsx'
import TranslateLink from '../../components/TranslateLink'

const Categories = ({ categories, onChange }) => {
  const list = chain(categories).values().sortBy("order").value()
  return (
    <Form inline className="carta-categories">
      <ol>
        {list.length == 0 && <i>No hay categorías</i>}
        {
          list.map(category => (
            <li key={category.id}>
              <FormControl 
                value={category.name} 
                placeholder="Nombre (esp)"
                onChange={evt => onChange({ ...categories, [category.id]: { ...category, name: evt.target.value } })} 
              />
              <div className="chname">
                <FormControl 
                  value={category.chName} 
                  placeholder="Nombre (ch)"
                  onChange={evt => onChange({ ...categories, [category.id]: { ...category, chName: evt.target.value } })} 
                />
                <TranslateLink text={category.chName} />
              </div>
              <FormControl 
                type="number"
                value={category.order} 
                onChange={evt => onChange({ ...categories, [category.id]: { ...category, order: parseInt(evt.target.value) } })} 
              />
              <Button 
                glyph="remove"
                onClick={() => onChange(omit(categories, category.id))}
              />
            </li>
          ))
        }
      </ol>
      <Button 
        glyph="plus" 
        onClick={() => {
          const id = randstr(8)
          onChange({
            ...categories,
            [id]: {
              id,
              order: parseInt(chain(categories).values().map("order").max().value() || 0) + 1,
              chName: "",
              name: "",
            }
          })
        }}
      >
        Añadir categoría
      </Button>

    </Form>
  )
}

Categories.propTypes = {
  categories: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default Categories
